import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getTaskDashboard, type GetTaskDashboardParams } from '../api/taskDashboard';

export function useTaskDashboard(params?: GetTaskDashboardParams) {
  return useQuery({
    queryKey: ['task-dashboard', JSON.stringify(params ?? {})],
    queryFn: () => getTaskDashboard(params),
    ...listQueryDefaults,
  });
}
